import {dbGet, dbPost} from 'utils/ajaxUtils';

export const getStartsCompletes = uid => dbGet(`users/${uid}/startscompletes`, {});

export const getRaffleEntries = uid => dbGet(`users/${uid}/raffleentries`, {});

export const getPrizeboothOrders = uid => dbGet(`users/${uid}/prizeboothorders`, {});

export const getPointHistory = uid => dbGet(`users/${uid}/coinhistory`, {});

export const awardPoints = (uid, amount, reason) => dbPost('users/awardcoins', {
  uid,
  amount,
  reason
});

export const awardSpins = (uid, amount) => dbPost('users/awardspins', {
  uid,
  amount
});

export const awardConsecutiveDays = (uid, amount) => dbPost('user/updateconsecutivedays', {
  uid,
  amount
});

export const changePassword = (uid, newPassword, newPasswordConfirm) => dbPost('user/changepassword', {
  uid,
  newPassword,
  newPasswordConfirm
});

export const revokePoints = (uid, phid /* point history id */) => dbPost('users/revokecoins', {
  uid,
  phid
});

export const revokeAmountOfPoints = (uid, amount, reason) => dbPost('users/revokepoints', {
  uid,
  amount,
  reason
});

export const repairProfile = uid => dbGet('user/fix', {
  uid
});

export const deleteUser = uid => dbPost(`user/delete/${uid}`, {});

export const undeleteUser = uid => dbPost(`user/undelete/${uid}`, {});

export const deleteUserData = uid => dbPost(`user/deletedata/${uid}`, {});



// WEBPACK FOOTER //
// ./public/api/user-management-legacy.js